<template>
  <v-container id="retrieveusername" fluid>
    <div
      class="d-flex flex-column"
      style="justify-content: center; align-items: center; gap: 12px"
    >
      <v-card max-width="420px" outlined>
        <v-form ref="form" v-model="valid" @submit.prevent="onSubmit">
          <v-card-title class="text-h4"> Retrieve Username</v-card-title>

          <v-card-text>
            <v-text-field
              v-model="formfields.email"
              :label="`${$i18n.t('labels.email')}*`"
              :rules="formRules.email"
              :readonly="submitting || (submitted && error === '')"
              required
            ></v-text-field>

            <v-row no-gutters class="text-caption">
              This site is protected by reCAPTCHA and the Google
              <a target="_blank" href="https://policies.google.com/privacy">
                &nbsp;Privacy Policy&nbsp;
              </a>
              and
              <a target="_blank" href="https://policies.google.com/terms">
                &nbsp;Terms of Service&nbsp;
              </a>
              apply.
            </v-row>
          </v-card-text>
          <!-- Submit button -->
          <v-card-actions class="px-4 pb-4 pt-0">
            <v-spacer></v-spacer>
            <v-btn
              :disabled="submitting || !valid || submitted || error !== ''"
              type="submit"
              x-large
              color="primary"
              :loading="submitting"
            >
              {{ $i18n.t("actions.submit") }}
            </v-btn>
            <v-btn
              v-if="submitted || error !== ''"
              x-large
              color="primary"
              @click="signIn"
            >
              Sign In
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-form>
      </v-card>

      <v-alert
        outlined
        v-if="error > ''"
        type="error"
        max-width="420px"
        width="420px"
      >
        <v-row align="center">
          <v-col class="grow text-subtitle-1"
            ><div v-html="error"></div>
          </v-col>
        </v-row>
      </v-alert>
      <v-alert
        outlined
        v-else-if="submitted"
        type="success"
        max-width="420px"
        width="420px"
      >
        <v-row align="center">
          <v-col class="grow text-subtitle-1">
            <div>Your username has been emailed to {{ formfields.email }}.</div>
            <ul>
              <li>
                The first character is '{{ username.charAt(0) }}' and the last
                is '{{ username.charAt(username.length - 1) }}'
              </li>
              <li>The username is {{ username.length }} characters long</li>
            </ul>
          </v-col>
        </v-row>
      </v-alert>
    </div>
  </v-container>
</template>

<script>
import { API } from "aws-amplify";

export default {
  name: "RetrieveUsername",
  data: () => ({
    valid: true,
    submitting: false,
    submitted: false,
    error: "",
    formfields: {
      email: "",
      recaptchaToken: "",
    },
    formRules: {
      email: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
    },
  }),
  computed: {
    maskedUsername() {
      if (!this.username) return "";
      const first = this.username.charAt(0);
      const last = this.username.charAt(this.username.length - 1);
      const middle = "*".repeat(this.username.length - 2);
      return this.username.length > 1
        ? `${first}${middle}${last}`
        : this.username;
    },
  },
  methods: {
    signIn() {
      this.$router.push("/app/products").catch((err) => {
        // console.error("Error: ", err);
      });
    },

    async onSubmit() {
      this.error = "";
      const token = await this.$recaptcha("submit");
      this.formfields.recaptchaToken = token;
      this.submitting = true;

      const email = this.formfields.email;

      const response = await API.get(
        "cognitolambdaapi",
        "/item/retrieveUsername",
        {
          queryStringParameters: {
            email: email,
            recaptchaToken: this.formfields.recaptchaToken,
          },
        }
      ).catch((error) => {
        console.error(error);
        return error?.response?.data;
      });

      console.log(response);
      if (response?.username) {
        this.username = response.username;
        this.submitted = true;
      } else if (response?.error) {
        this.error =
          response.error.type === "reCaptchaFail"
            ? this.$i18n.t("lambda.reCaptchaFail")
            : response.error.type === "errorSendingEmail"
            ? this.$i18n.t("lambda.errorSendingEmail")
            : response.error.type === "internalServerError"
            ? this.$i18n.t("lambda.internalServerError")
            : response.error.type === "noValidUser"
            ? this.$i18n.t("lambda.noValidUser")
            : this.$i18n.t("lambda.errorNoProfile");
      } else {
        this.error = this.$i18n.t("lambda.errorNoProfile");
      }

      this.submitting = false;
    },
  },
};
</script>
